import { z } from 'zod';

/**
 * Gespeicherte Zahlungsbedingungs-Vorlage (Beleg-Notiz). Tenant-weit kuratiert,
 * in Verkauf UND Einkauf im Notiz-/Zahlungsbedingungsfeld einfügbar. `body` ist
 * derselbe Mini-Markdown wie die Notiz (### Überschrift, **fett**, - Punkte).
 */
export const paymentTermsTemplateResponseSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  body: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type PaymentTermsTemplateResponse = z.infer<typeof paymentTermsTemplateResponseSchema>;

export const createPaymentTermsTemplateSchema = z.object({
  name: z.string().trim().min(1).max(120),
  body: z.string().trim().min(1).max(5000),
});
export type CreatePaymentTermsTemplateInput = z.infer<typeof createPaymentTermsTemplateSchema>;

export const updatePaymentTermsTemplateSchema = z.object({
  name: z.string().trim().min(1).max(120).optional(),
  body: z.string().trim().min(1).max(5000).optional(),
});
export type UpdatePaymentTermsTemplateInput = z.infer<typeof updatePaymentTermsTemplateSchema>;
